import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SIcon, SRow } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { formatPrice } from '../../../../shared/helpers';
import conf from '../../../conf';
import { getOfferPlanPrice } from '../../../lib/offers';
import { fetchOffer } from '../../../lib/side-effects/offers';
import { exitQuestionnaire } from '../../../lib/side-effects/prequal-questionnaire';
import { selectState } from '../../../selectors';
import { getCtaUrlWithCampaignId } from '../../helpers/prequal-questionnaire';
import { appendQueryParamToUrl } from '../../helpers/redirect';
import { ReviewBox } from '../../styled/skylab/box';

const RegistrationsNextSteps = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(fetchOffer('avalara-licensing'));
  }, []);

  const {
    questionnaire: { config, selectedAnswers },
    offer: { plans },
  } = useSelector(selectState);
  const endPageData = config?.endPage.content;

  if (!endPageData) {
    return null;
  }

  const licensePrice = getOfferPlanPrice(plans[0]);
  const exceeding = selectedAnswers.exceedingNexusThresholds || [];
  const approaching = selectedAnswers.approachingNexusThresholds || [];
  const states = exceeding.concat(approaching).sort();
  const totalAmount = licensePrice * states.length;
  const numberOfStates = states.length;
  const campaignId = config?.campaignId || '';
  const ctaButtonUrl = getCtaUrlWithCampaignId(campaignId, `${conf.BUY_CLIENT_URL}${endPageData.actionButtonUrl}`);
  const ctaButtonUrlWithQty = appendQueryParamToUrl(ctaButtonUrl, `quantity=${numberOfStates}`);

  return (
    <div className='App-page'>
      <SRow className='margin-left-md margin-top-xl margin-right-md'>
        <SCol span='md-7 8' className='pad-bottom-none'>
          <h1 data-ref='buy.prequal.registration-next-steps.header' className='margin-bottom-md'>
            {endPageData.heading}
          </h1>
          <p data-ref='buy.prequal.registration-next-steps.body'>{endPageData.body}</p>
          <h3 data-ref='buy.prequal.registration-next-steps.subheading' className='margin-top-xl'>
            {endPageData.subHeading}
          </h3>
          <p>{endPageData.subText}</p>
          <div className='flex flex-dir-row align-items-center margin-top-xl pad-bottom-xl'>
            <button
              type='button'
              data-ref='buy.prequal.registration-next-steps.go-back-button'
              className='secondary active large'
              onClick={() => history.goBack()}
            >
              {t('client.buttons.back')}
            </button>
            <button
              type='button'
              data-ref='buy.prequal.registration-next-steps.cta-button'
              className='primary large'
              onClick={() => dispatch(exitQuestionnaire(ctaButtonUrlWithQty))}
            >
              {endPageData.actionButtonText}
            </button>
          </div>
        </SCol>
        <SCol span='md-5 4' className='pad-bottom-none'>
          <div style={{ minWidth: '350px' }} data-ref='buy.prequal.registration-next-steps.review-container'>
            <ReviewBox>
              <div className='flex flex-dir-row'>
                <p className='text-sm-strong'>
                  <SIcon name='certificate-2' className='medium text-md pad-right-sm' aria-label='certificate' />
                  {t('client.general.you-selected-registrations-to-purchase', { count: numberOfStates })}
                </p>
              </div>
              <hr className='margin-right-sm' />
              <div style={{ maxHeight: '320px', overflow: 'auto' }}>
                <SRow className='pad-top-xs flex flex-dir-col pad-right-sm'>
                  {states.map((text) => (
                    <div
                      key={text}
                      className='flex flex-dir-row pad-bottom-xs justify-content-space'
                      style={{ alignItems: 'baseline' }}
                    >
                      <p className='text-capitalize'>
                        <SIcon name='check' className='pad-right-xs text-blue-medium' /> {text}
                      </p>
                      <p className='text-right'>{formatPrice(licensePrice, 2)}</p>
                    </div>
                  ))}
                </SRow>
              </div>
              <hr className='margin-right-sm' />
              <div className='flex flex-dir-row justify-content-space pad-right-sm text-sm-strong'>
                <p>{t('client.general.total')}</p>
                <p className='text-right'>{formatPrice(totalAmount, 2)}</p>
              </div>
            </ReviewBox>
          </div>
        </SCol>
      </SRow>
    </div>
  );
};
export default RegistrationsNextSteps;
